import { useState } from 'react';

interface FaqItem {
  q: string;
  a: string;
}

interface FaqCategory {
  id: string;
  label: string;
  icon: string;
  items: FaqItem[];
}

const faqData: FaqCategory[] = [
  {
    id: '보험 청구',
    label: '보험 청구',
    icon: 'ri-shield-check-line',
    items: [
      {
        q: '가족이 간병해도 보험금 지급이 가능한가요?',
        a: '가능합니다. 대부분의 간병보험은 가족이 직접 간병해도 조건만 충족하면 보험금 지급이 가능합니다. 보험사별로 필요 서류와 인정 기준이 조금씩 다르니 코리아케어러스에 문의하시면 정확히 안내해 드립니다.',
      },
      {
        q: '간병비 소급 적용이 가능한가요?',
        a: '불가능합니다. 간병인은 등록된 일자부터 자격이 인정되며, 등록 이전의 간병 이력은 보험사에서 인정되지 않아 소급 적용이 불가합니다. 소급적용이 된다고 하는 업체가 있다면 주의하셔야 합니다. 코리아케어러스는 정도영업을 준수합니다.',
      },
      {
        q: '보험 청구는 어떤 절차로 진행되나요?',
        a: '코리아케어러스에 가족간병인으로 등록 → 간병 시작 → 퇴원 후 필요 서류(입퇴원확인서, 간병일지, 간병비 이체 영수증, 간병인 신분증 사본) 카카오톡으로 전송 → 코리아케어러스 서류 검토 후 보험사 제출 → 보험금 수령 순으로 진행됩니다.',
      },
      {
        q: '보험 청구 후 보험금은 얼마나 걸려 지급되나요?',
        a: '보험사마다 다르지만 일반적으로 서류 제출 후 7~14 영업일 이내에 보험금이 지급됩니다. 서류 누락이나 보험사 심사 지연으로 추가 시간이 소요될 수 있으며, 진행 상황은 저희를 통해 확인하실 수 있습니다.',
      },
      {
        q: '여러 보험사에 중복 청구가 가능한가요?',
        a: '네, 가능합니다. 간병보험은 실손보험과 달리 정액 지급 방식으로 여러 보험사에 중복 청구가 가능합니다. 가입하신 보험 내역을 모두 확인하여 빠짐없이 청구하시길 권장합니다.',
      },
    ],
  },
  {
    id: '간병인 등록',
    label: '간병인 등록',
    icon: 'ri-user-heart-line',
    items: [
      {
        q: '간병인 자격증 없이 가족 간병이 가능한가요?',
        a: '물론입니다. 가족간병인은 별도의 국가자격증이나 교육 과정이 필요하지 않습니다. 코리아케어러스에 공식적으로 등록만 해도 보험사에서 인정하는 간병인으로 활동하실 수 있습니다.',
      },
      {
        q: '가족간병인 등록은 어떻게 하나요?',
        a: '홈페이지 \'가족간병 등록\' 메뉴에서 간단한 정보를 입력하거나, 전화(1566-8654)로 연락주시면 담당자가 등록 절차를 안내해 드립니다. 등록은 5분 이내로 빠르게 완료됩니다.',
      },
      {
        q: '등록 후 바로 간병을 시작할 수 있나요?',
        a: '네, 등록 완료 즉시 간병을 시작하실 수 있습니다. 단, 등록 이전의 간병 기간은 소급 인정이 되지 않으므로, 입원과 동시에 혹은 간병 시작 전에 반드시 먼저 등록해 주세요.',
      },
      {
        q: '배우자나 직계가족이 아니어도 등록이 가능한가요?',
        a: '가능합니다. 형제자매, 며느리·사위 등 가족 범위 내의 분들도 등록 가능합니다. 단, 보험사별로 인정하는 간병인 범위가 다를 수 있으니 가입 보험 약관을 확인하거나 저희에게 문의해 주세요.',
      },
    ],
  },
  {
    id: '서류 안내',
    label: '서류 안내',
    icon: 'ri-file-list-3-line',
    items: [
      {
        q: '코리아케어러스에 제출해야 할 서류가 뭔가요?',
        a: '퇴원 시 ① 입·퇴원 확인서 ② 간병일지(코리아케어러스 공식 양식) ③ 간병비 이체 영수증(1일 최소 10만원) ④ 간병인 신분증 앞면, 이 4가지를 카카오톡 채팅방으로 보내주시면 됩니다.',
      },
      {
        q: '간병일지는 어디서 받을 수 있나요?',
        a: '코리아케어러스 홈페이지의 \'간병인 배정 후 필수사항\' 또는 \'필요서류 안내\' 페이지에서 JPG 또는 PDF 파일로 다운로드하실 수 있습니다. 프린트하여 매일 작성하신 후 간병인 서명을 받아 보관해 주세요.',
      },
      {
        q: '간병일지는 반드시 매일 작성해야 하나요?',
        a: '네, 필수입니다. 간병일지는 보험사에서 간병 사실을 인정하는 핵심 서류입니다. 간병 기간 동안 매일 작성하고, 간병인 서명을 받아야 보험금 청구 시 인정받을 수 있습니다.',
      },
      {
        q: '간병비는 어떻게 이체해야 하나요?',
        a: '간병비는 간병인과 환자가 직접 협의하여 이체합니다. 보험 청구를 위해서는 보험 청구자 본인 명의 계좌에서 간병인 본인 명의 계좌로 이체한 내역(거래 영수증)이 필요합니다. 현금 지급이나 제3자 명의 이체는 보험사에서 인정받지 못할 수 있습니다.',
      },
    ],
  },
  {
    id: '비용 안내',
    label: '비용 안내',
    icon: 'ri-coin-line',
    items: [
      {
        q: '코리아케어러스 서비스 이용 비용이 있나요?',
        a: '코리아케어러스는 간병인과 환자를 연결하는 플랫폼으로, 가족간병 수수료를 받습니다. 가족간병 수수료는 일 4,000원을 기준으로 하되 최소 10,000원, 최대 100,000원으로 책정됩니다. 예를 들어 1~2일은 10,000원, 3일은 12,000원이며, 기간에 상관없이 최대 100,000원입니다. 또한 기본 간병인 1명을 기준으로, 간병인이 추가되면 추가 인원 1명당 10,000원이 부과됩니다. 숨겨진 추가 비용은 없으며, 자세한 내용은 전화(1566-8654) 또는 홈페이지를 통해 문의해 주시면 상세히 안내해 드립니다.',
      },
      {
        q: '간병비는 하루에 얼마나 이체해야 하나요?',
        a: '보험사에서 정상 간병으로 인정받기 위해서는 1일 최소 10만원 이상 이체해야 합니다. 이체 금액이 이보다 적을 경우 보험금 청구가 거절되거나 감액될 수 있습니다.',
      },
      {
        q: '보험금 수령 금액은 어떻게 결정되나요?',
        a: '보험금은 가입하신 보험 약관에 따라 결정됩니다. 일반적으로 간병 일수 × 일당 보험금으로 계산되며, 보험사 및 가입 플랜에 따라 금액이 다릅니다. 가입 내역을 확인하시거나 저희에게 문의해 주시면 예상 보험금을 안내해 드립니다.',
      },
    ],
  },
  {
    id: '기타 문의',
    label: '기타 문의',
    icon: 'ri-chat-smile-3-line',
    items: [
      {
        q: '가족간병은 전국 어디서든 이용할 수 있나요?',
        a: '네, 코리아케어러스는 전국을 대상으로 가족간병 등록과 간병보험 청구 서류 발급을 지원합니다. 본사는 전주에 있지만 거주 지역과 상관없이 전화·온라인으로 등록과 상담이 가능하며, 필요 서류도 발급 후 받아보실 수 있습니다.',
      },
      {
        q: '입원 기간 중 간병인이 교대해도 되나요?',
        a: '네, 가능합니다. 다만 교대하는 간병인도 모두 코리아케어러스에 등록되어 있어야 하며, 각 간병인별로 간병일지를 정확히 작성하고 이체 내역을 유지해야 합니다.',
      },
      {
        q: '이미 퇴원했는데 청구가 가능한가요?',
        a: '등록 이전 기간의 소급 적용은 불가하지만, 등록 기간 내 간병에 대해서는 퇴원 후에도 청구가 가능합니다. 단, 필요 서류(간병일지, 이체 내역 등)가 갖춰져 있어야 합니다. 자세한 사항은 상담을 통해 확인해 드립니다.',
      },
      {
        q: '카카오톡으로도 상담이 가능한가요?',
        a: '네, 가능합니다. 서류 제출도 카카오톡 채팅방을 통해 진행하시면 됩니다. 전화(1566-8654) 또는 채팅 상담 모두 평일 오전 9시 ~ 오후 6시에 이용하실 수 있습니다.',
      },
      {
        q: '간병인도 소득신고를 해야 하나요?',
        a: '네, 간병인은 간병으로 발생한 수익에 대한 소득세 및 세무 신고 의무가 있습니다. 소득신고는 간병인 본인이 직접 하셔야 하며, 코리아케어러스는 중개 플랫폼으로서 간병인의 소득신고를 대행하지 않습니다. 소득신고 관련 문의는 가까운 세무서 또는 세무사에게 상담하시기 바랍니다.',
      },
    ],
  },
];

interface AccordionItemProps {
  item: FaqItem;
  index: number;
  isOpen: boolean;
  onToggle: () => void;
}

function AccordionItem({ item, index, isOpen, onToggle }: AccordionItemProps) {
  return (
    <div
      className="rounded-xl overflow-hidden border transition-all"
      style={{ borderColor: isOpen ? '#2E7D6B' : '#f0f0f0' }}
    >
      <button
        className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
        onClick={onToggle}
      >
        <span className="text-sm font-semibold text-gray-900 flex items-center gap-3">
          <span
            className="w-7 h-7 flex items-center justify-center rounded-lg text-xs font-bold flex-shrink-0 transition-colors"
            style={{
              backgroundColor: isOpen ? '#2E7D6B' : '#e8f5f1',
              color: isOpen ? '#fff' : '#2E7D6B',
            }}
          >
            Q
          </span>
          {item.q}
        </span>
        <i
          className={`ri-${isOpen ? 'subtract' : 'add'}-line flex-shrink-0 ml-3 transition-colors text-base`}
          style={{ color: isOpen ? '#2E7D6B' : '#9ca3af' }}
        ></i>
      </button>
      {isOpen && (
        <div className="px-6 pb-5 flex gap-3">
          <span
            className="w-7 h-7 flex items-center justify-center rounded-lg text-xs font-bold flex-shrink-0 mt-0.5"
            style={{ backgroundColor: '#e8f5f1', color: '#2E7D6B' }}
          >
            A
          </span>
          <p className="text-sm text-gray-600 leading-relaxed">{item.a}</p>
        </div>
      )}
    </div>
  );
}

export default function FaqList() {
  const [activeCategory, setActiveCategory] = useState('보험 청구');
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  const currentCategory = faqData.find((c) => c.id === activeCategory)!;

  const handleCategoryChange = (id: string) => {
    setActiveCategory(id);
    setOpenIdx(0);
  };

  return (
    <section className="w-full py-16" style={{ backgroundColor: '#f9fdfb' }}>
      <div className="max-w-5xl mx-auto px-6">
        <div className="flex flex-col md:flex-row gap-8 items-start">
          {/* Left: Category sidebar */}
          <div className="w-full md:w-52 flex-shrink-0 md:sticky md:top-24">
            <p className="text-xs font-semibold tracking-widest uppercase mb-4 text-gray-400">CATEGORY</p>
            <div className="flex flex-row md:flex-col flex-wrap gap-2">
              {faqData.map((cat) => (
                <button
                  key={cat.id}
                  id={cat.id}
                  onClick={() => handleCategoryChange(cat.id)}
                  className="flex items-center gap-2 px-4 py-3 rounded-xl text-sm font-medium cursor-pointer transition-all text-left whitespace-nowrap"
                  style={{
                    backgroundColor: activeCategory === cat.id ? '#2E7D6B' : '#fff',
                    color: activeCategory === cat.id ? '#fff' : '#6b7280',
                    border: activeCategory === cat.id ? '1.5px solid #2E7D6B' : '1.5px solid #e5e7eb',
                  }}
                >
                  <i className={`${cat.icon} text-sm`}></i>
                  {cat.label}
                  <span
                    className="ml-auto text-xs font-semibold rounded-full px-1.5 py-0.5 leading-none"
                    style={{
                      backgroundColor: activeCategory === cat.id ? 'rgba(255,255,255,0.25)' : '#f3f4f6',
                      color: activeCategory === cat.id ? '#fff' : '#9ca3af',
                    }}
                  >
                    {cat.items.length}
                  </span>
                </button>
              ))}
            </div>
          </div>

          {/* Right: Accordion */}
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-3 mb-6">
              <div
                className="w-9 h-9 flex items-center justify-center rounded-xl"
                style={{ backgroundColor: '#e8f5f1' }}
              >
                <i className={`${currentCategory.icon} text-base`} style={{ color: '#2E7D6B' }}></i>
              </div>
              <div>
                <h2 className="text-lg font-bold text-gray-900">{currentCategory.label}</h2>
                <p className="text-xs text-gray-400">총 {currentCategory.items.length}개의 질문</p>
              </div>
            </div>
            <div className="flex flex-col gap-3">
              {currentCategory.items.map((item, i) => (
                <AccordionItem
                  key={`${activeCategory}-${i}`}
                  item={item}
                  index={i}
                  isOpen={openIdx === i}
                  onToggle={() => setOpenIdx(openIdx === i ? null : i)}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
